import { HiverAxios, setHiddenLoadingBar, delay } from 'h-commons';
import { FETCH_USERS_AND_GROUPS_INIT, FETCH_USERS_AND_GROUPS_DONE, FETCH_USERS_AND_GROUPS_FAILED, RESET_USERS_PAGINATION } from './types';
import { isAddNewUserEnabled } from '../../common/helpers/featureKeys';
/**
 * Dispatches action on successful fetching of users and groups 
 */
export function getAccountUsers(fresh, hiddenRequest) {
  return (dispatch, getState) => {
    if (fresh) {
      dispatch({ type: RESET_USERS_PAGINATION });
    }
    const state = getState();
    const { 
      usersAndGroups: { usersPagination },
      userDetails: { availableFeatures }
    } = state;

    const fetchInboxData = isAddNewUserEnabled(availableFeatures)? 1 : 0

    if (usersPagination.done) return;
    dispatch({
      type: FETCH_USERS_AND_GROUPS_INIT
    });
    hiddenRequest && dispatch(setHiddenLoadingBar(true));
    HiverAxios({
      url: '/api/settings/users',
      type: 'GET',
      params: {
        index: usersPagination.lastId,
        limit: usersPagination.limit,
        fetch_inbox_data: fetchInboxData
      },
      callback: (response) => {
        response = response.data;
        if (response.success) {
          dispatch({
            type: FETCH_USERS_AND_GROUPS_DONE,
            payload: response.data
          });
          delay(300).then(() => dispatch(getAccountUsers(false, hiddenRequest)))
        } else {
          dispatch({
            type: FETCH_USERS_AND_GROUPS_FAILED,
            payload: 'Fetching failed for users and groups'
          });
        }
        hiddenRequest && dispatch(setHiddenLoadingBar(false));
      },
      onfail: () => {
        dispatch({
          type: FETCH_USERS_AND_GROUPS_FAILED,
          payload: 'Fetching error for users and groups'
        });
        hiddenRequest && dispatch(setHiddenLoadingBar(false));
      }
    });
  };
}
